'use client'

import { cn } from '@/lib/utils'

import {
  EASE,
  HAIRLINE,
  InlineLink,
  QuietLink,
  SectionHead,
  useReveal,
} from '@/components/page-kit'
import { ACCOUNTS } from './data'

/* The eight authored capability lines, verbatim, on the same centre axis the
   ledger section uses: number against the rule on one side, the line on the
   other. No checkmark icons.

   "What's included" is a structural label, not a claim. */

export function AccountsIncluded() {
  const list = useReveal<HTMLDivElement>(0.1)

  return (
    <section id="included" className="scroll-mt-24 pt-16 sm:pt-20 md:pt-28">
      <div className="container mx-auto">
        <SectionHead
          eyebrow="Scope"
          title="What's included."
          action={
            <QuietLink href="/product-brochure">
              Download the brochure
            </QuietLink>
          }
        />

        <div
          ref={list.ref}
          className={cn(
            'mt-10 grid grid-cols-1 gap-x-12 border-t sm:mt-12 lg:grid-cols-2',
            HAIRLINE
          )}
        >
          {ACCOUNTS.capabilities.map((c, i) => (
            <div
              key={c}
              className={cn(
                'flex items-baseline gap-4 border-b py-4 sm:py-5',
                HAIRLINE
              )}
              style={{
                opacity: list.shown ? 1 : 0,
                transform: list.shown ? 'none' : 'translateY(8px)',
                transition: `opacity 460ms ${EASE} ${i * 60}ms, transform 460ms ${EASE} ${i * 60}ms`,
              }}
            >
              <span className="shrink-0 text-[11px] tabular-nums text-muted-foreground/60">
                {String(i + 1).padStart(2, '0')}
              </span>
              <p className="font-heading text-base font-normal leading-snug text-foreground sm:text-lg">
                {c}
              </p>
            </div>
          ))}
        </div>

        {/* Same capability, read from the school's side of the platform. */}
        <p className="mt-8 max-w-2xl text-sm leading-relaxed text-muted-foreground sm:text-base">
          In a school or college the same ledger sits behind the{' '}
          <InlineLink href="/schoolerp/features/accounts-finance">
            accounts and bookkeeping module
          </InlineLink>
          , with tuition posted to it by the{' '}
          <InlineLink href="/schoolerp/features/fee-finance">
            fee collection module
          </InlineLink>{' '}
          in <InlineLink href="/schoolerp">Euclideum School ERP</InlineLink>.
        </p>
      </div>
    </section>
  )
}
